// Route d'accueil par rôle après connexion.
export function roleHome(role) {
  switch (role) {
    case 'super_admin':
      return '/admin';
    case 'educateur':
      return '/educateur';
    case 'parent':
      return '/parent';
    case 'benevole':
      return '/benevole';
    case 'membre':
    case 'joueur':
    case 'adherent':
      return '/espace';
    default:
      // president + rôles du bureau (vice_president, secretaire, vice_secretaire, tresorier)
      return '/dashboard';
  }
}
